// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2QS07","subheader":"ReorderModal_subheader__YVXLb","listWrap":"ReorderModal_listWrap__2vjJs"};